import { Container, Stack, Box } from "@mui/material";
import Header from "../components/Header";
import Footer from "../components/Footer";

type Props = {
  children: React.ReactNode;
};

function App({ children }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100vw",
        overflowX: "hidden",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Header />

      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100vw",
          px: 0,
        }}
      >
        <Stack
          sx={{
            // py: 12,
            // maxWidth: 800,
            textAlign: "center",
            width: "100%",
          }}
        >
          {children}
        </Stack>
      </Box>

      <Footer />
    </Box>
  );
}

export default App;
